import ResponsiveField from '../responsivefield'
import Form from '@admin/components/form'
import RadiusField from '../radiusfield'
import BorderField from '../borderfield'
import LinkedField from '../linkedfield'
import ColorField from '../colorfield'
import WebRange from '../webrange'
import PropTypes from 'prop-types'
import React from 'react'

const Color = (props) => <ResponsiveField { ...props } component={ ColorField } />
const Range = (props) => <ResponsiveField { ...props } component={ WebRange } />
const Linked = (props) => <ResponsiveField { ...props } component={ LinkedField } />
const Border = (props) => <ResponsiveField { ...props } component={ BorderField } />
const Radius = (props) => <ResponsiveField { ...props } component={ RadiusField } />

class MarkerStyleField extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.object,
    device: PropTypes.string,
    theme: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    marker: null
  }

  _handleChange = _.debounce(this._handleChange.bind(this), 100, { trailing: true })
  _handleSet = this._handleSet.bind(this)

  render() {
    if(!this.state.marker) return null
    return (
      <div className="mjson-designer-stylefield">
        <Form { ...this._getForm() } />
      </div>
    )
  }

  componentDidMount() {
    const defaultValue = this._getDefaultValue()
    this._handleSet(defaultValue)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props
    const { marker } = this.state
    if(!_.isEqual(marker, prevState.marker)) {
      this._handleChange()
    }
    if(!_.isEqual(value, prevProps.value)) {
      this._handleSet(value)
    }
  }

  _getForm() {
    const { device, theme } = this.props
    const { marker } = this.state
    return {
      inline: true,
      onChange: this._handleSet,
      sections: [
        {
          fields: [
            { label: 't(Size)', name: 'size', device, type: Range, units: [
              { name: 'px', min: 15, max: 100, step: 1 }
            ], defaultValue: '15px', value: marker.size },
            { label: 't(Background Color)', name: 'backgroundColor', device, theme, type: Color, defaultColor: true, value: marker.backgroundColor },
            { label: 't(Color)', name: 'color', type: Color, device, theme, defaultColor: true, value: marker.color },
            { label: 't(Border)', name: 'border', device, theme, type: Border, value: marker.border },
            { label: 't(Rounded Corners)', name: 'radius', device, theme, type: Radius, value: marker.radius },
            { label: 't(Margin)', name: 'margin', device, type: Linked, units: [
              { name: 'px', min: 0, max: 100, step: 1 }
            ], types: ['top','right','bottom','left'], nullValues: ['0px'], defaultValue: '0px', value: marker.margin },
            { label: 't(Padding)', name: 'padding', device, type: Linked, units: [
              { name: 'px', min: 0, max: 100, step: 1 }
            ], types: ['top','right','bottom','left'], nullValues: ['0px'], defaultValue: '0px', value: marker.padding }
          ]
        }
      ]
    }
  }

  _getDefaultValue() {
    const { defaultValue, value } = this.props
    return !_.isNil(value) ? value : !_.isNil(defaultValue) ? defaultValue : null
  }

  _handleChange() {
    const { marker } = this.state
    this.props.onChange(marker)
  }

  _handleSet(marker) {
    this.setState({
      marker: {
        ...marker
      }
    })
  }

}

export default MarkerStyleField
